module.exports = __webpack_public_path__ + "static/media/LVS_02.b7d73e70.jpeg";